"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SpiderChart = require("./SpiderChart");
Object.keys(_SpiderChart).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SpiderChart[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SpiderChart[key];
    }
  });
});